import { CodeISO2 } from "@mindlercare/schema";
import FlagSE from "./se.svg?react";
import FlagDK from "./dk.svg?react";
import FlagGB from "./gb.svg?react";
import FlagNL from "./nl.svg?react";
import FlagNO from "./no.svg?react";
import { defaultTheme as theme } from "../../shared/constants";

export type Size = "Normal" | "Large";

export const Flag = ({
  market,
  size = "Normal",
}: {
  size?: Size;
  market?: CodeISO2;
}) => {
  const width =
    size === "Normal" ? theme.FONT.SIZE.STANDARD : theme.FONT.SIZE.LARGE;
  switch (market) {
    case "SE":
      return <FlagSE width={width} />;
    case "DK":
      return <FlagDK width={width} />;
    case "GB":
      return <FlagGB width={width} />;
    case "NL":
      return <FlagNL width={width} />;
    case "NO":
      return <FlagNO width={width} />;
    default:
      return null;
  }
};
